import { withRouter } from '@om1/platform-routing'
import { connectRedux } from '@om1/platform-utils'
import { PlatformSettingsState } from '../state'
import { generalSettingsActions } from '../state/general-settings'
import { GeneralSettingsPageComponent } from './GeneralSettingsPageComponent'

export function createGeneralSettingsPage<TState extends { platformSettings: PlatformSettingsState }>() {
    return connectRedux(
        withRouter(GeneralSettingsPageComponent, { namespace: 'general-settings', dataFetchAction: 'getOrganizationSettings' }),
        (state: TState) => {
            return {
                generalSettings: state.platformSettings.generalSettings
            }
        },
        { ...generalSettingsActions }
    )
}

export type GeneralSettingsPage = ReturnType<typeof createGeneralSettingsPage>
